import { render, staticRenderFns } from "./event-list-of-us.vue?vue&type=template&id=09a76e77&"
import script from "./event-list-of-us.vue?vue&type=script&lang=js&"
export * from "./event-list-of-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventListOfUs: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/EventListOfUs/index.vue').default})
